﻿import { ImageCache } from "../imageCache";

/**
 * オンメモリで画像キャッシュする。
 */
export default class OnMemoryImageCache implements ImageCache {
  /** キャッシュ本体
   * @todo: 2019-06-18 現在では、際限なくメモリにキャッシュしてゆく
   */
  private cache: Map<string, HTMLImageElement>;

  constructor() {
    this.cache = new Map<string, HTMLImageElement>();
  }

  public clear(): void {
    this.cache.clear();
  }

  public get(key: string): HTMLImageElement | null {
    return this.cache.has(key)
      ? (this.cache.get(key) as HTMLImageElement)
      : null;
  }

  public set(key: string, image: HTMLImageElement): void {
    this.cache.set(key, image);
  }
}
